import { render, staticRenderFns } from "./EventListTableView.vue?vue&type=template&id=63898b60&scoped=true&"
import script from "./EventListTableView.vue?vue&type=script&lang=js&"
export * from "./EventListTableView.vue?vue&type=script&lang=js&"
import style0 from "./EventListTableView.vue?vue&type=style&index=0&id=63898b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63898b60",
  null
  
)

export default component.exports